(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProClaimConfDeleteController',ProClaimConfDeleteController);

    ProClaimConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProClaimConf'];

    function ProClaimConfDeleteController($uibModalInstance, entity, ProClaimConf) {
        var vm = this;

        vm.proClaimConf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProClaimConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
